/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Rule_Sets_CountInputs */

const en_tables_custom_properties_rule_sets_count = /** @type {(inputs: Tables_Custom_Properties_Rule_Sets_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_tables_custom_properties_rule_sets_count = /** @type {(inputs: Tables_Custom_Properties_Rule_Sets_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Regeln`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Tables_Custom_Properties_Rule_Sets_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_rule_sets_count = /** @type {((inputs?: Tables_Custom_Properties_Rule_Sets_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Rule_Sets_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_rule_sets_count(inputs)
	return de_tables_custom_properties_rule_sets_count(inputs)
});